import React from 'react';
import { useSelector } from 'react-redux';

import BrowseAvailablePuppiesCard from './BrowseAvailablePuppiesCard';

export default function BrowseAvailablePuppiesSection() {
  const { breedData, overviewPageData } = useSelector(({ server }) => server);

  return (
    <div className="BreedOverviewBrowseAvailablePuppiesSection ph5 pb10">
      <h5 className="lh-normal f4 f6-md mb2 tc-l">Browse available puppies</h5>
      <p className="dark-silver font-16-mobile mb2 tc-l">
        Connect with reputable breeders to find the dog of your dreams
      </p>
      <div className="flex flex-wrap justify-center">
        <div className="mr5-md mt4">
          {breedData.available_puppies_text && (
            <BrowseAvailablePuppiesCard
              header={breedData.available_puppies_text}
              subheader={breedData.average_price_text}
              url={`${breedData.search_results_path}`}
              photo={overviewPageData.available_puppies_photos[0]}
            />
          )}
        </div>
        <div className="mt4">
          <BrowseAvailablePuppiesCard
            header={breedData.certified_breeders_text}
            subheader={breedData.active_litters_text}
            url={`${breedData.search_results_path}?results_type=breeders`}
            photo={overviewPageData.available_puppies_photos[1]}
          />
        </div>
      </div>
    </div>
  );
}
